import { createContext, useEffect, useMemo, useState } from 'react';

export const AuthContext = createContext({
    isAuthenticated: false,
    user: null,
    login: () => {},
    logout: () => {},
});

export default function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // Sayfa yüklendiğinde localStorage'dan auth bilgilerini yükle
    useEffect(() => {
        const initializeAuth = () => {
            try {
                const storedUser = localStorage.getItem('auth:user');
                
                if (storedUser) {
                    try {
                        const parsedUser = JSON.parse(storedUser);
                        setUser(parsedUser);
                        console.log('✅ User authenticated from localStorage:', parsedUser);
                    } catch (parseError) {
                        console.error('❌ Error parsing stored user:', parseError);
                        localStorage.removeItem('auth:user');
                    }
                }
            } catch (error) {
                console.error('❌ Error initializing auth:', error);
            } finally {
                setIsLoading(false);
            }
        };

        initializeAuth();
    }, []);

    const login = (nextUser, token) => {
        const userToSet = nextUser || { id: 'demo', name: 'Demo User' };
        
        // localStorage'a kaydet
        localStorage.setItem('auth:user', JSON.stringify(userToSet));
        if (token) {
            localStorage.setItem('auth:token', token);
        }
        
        // State'i güncelle
        setUser(userToSet);
    };

    const logout = () => {
        // State'i temizle
        setUser(null);
        
        // localStorage'ı temizle
        localStorage.removeItem('auth:user');
        localStorage.removeItem('auth:token');
    };

    // Basit kontrol: localStorage'da auth:user varsa giriş yapılmış
    const isAuthenticated = Boolean(localStorage.getItem('auth:user'));

    const value = useMemo(() => ({
        isAuthenticated,
        user,
        login,
        logout,
        isLoading,
    }), [user, isLoading]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}


